/**
 * @generated SignedSource<<05ea6142a0651beccf4982e7b4edc421>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type sectionViewRendererFragment$data = {
  readonly __id: string;
  readonly subsections: ReadonlyArray<{
    readonly __id: string;
    readonly elements: ReadonlyArray<{
      readonly __typename: string;
      readonly __id: string;
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"subsectionViewRendererFragment">;
  } | null | undefined> | null | undefined;
  readonly visualConfig: {
    readonly backgroundColor: string | null | undefined;
    readonly backgroundImage: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly hidden: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "sectionViewRendererFragment";
};
export type sectionViewRendererFragment$key = {
  readonly " $data"?: sectionViewRendererFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionViewRendererFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "sectionViewRendererFragment",
  "selections": [
    {
      "concreteType": "HelpLayoutSubsection",
      "kind": "LinkedField",
      "name": "subsections",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "subsectionViewRendererFragment"
        },
        {
          "kind": "LinkedField",
          "name": "elements",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            (v0/*: any*/)
          ]
        },
        (v0/*: any*/)
      ]
    },
    {
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "backgroundColor"
        },
        {
          "concreteType": "HelpLayoutBackgroundImage",
          "kind": "LinkedField",
          "name": "backgroundImage",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "url"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "hidden"
        }
      ]
    },
    (v0/*: any*/)
  ],
  "type": "HelpLayoutSection"
};
})();

(node as any).hash = "1c2dadd8fbad99920217ee977a705f13";

export default node;
